import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {QueryKeyName, createAction} from '../../common/backend'
import {FEATURE_NAMESPACE} from '../../consts'
import {ActionItem, CreateActionItem} from '../../types'
import {usePlantUpmId} from '../usePlantUpmIdContext'

export const useCreateAction = (onSuccess?: (item: ActionItem) => void) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const plantId = usePlantUpmId()
  const client = useQueryClient()

  return useMutation({
    mutationFn: (actionItem: CreateActionItem) => createAction({plantId, actionItem}),
    onSuccess: (item: ActionItem) => {
      void client.invalidateQueries({queryKey: [QueryKeyName.GetActionItems]})
      spawnSuccessToast(t('addAction.afterSubmit.success'))
      onSuccess?.(item)
    },
    onError: () => {
      spawnErrorToast(t('addAction.afterSubmit.error'))
    }
  })
}
